import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Email } from 'src/models/email.model';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  private apiUrl = `${environment.apiBaseUrl}/email`;
  private NUMERO_TENTATIVAS_REQUEST = 0;

  constructor(private http: HttpClient) { }

  enviaEmailNovoCadastro(email: Email) {
    return this.http
      .post<any>(`${this.apiUrl}`, email)
      .pipe(retry(this.NUMERO_TENTATIVAS_REQUEST), catchError(this.handleError));
  }

  enviaEmailConfirmacaoLimpezaFazenda(email: Email): Observable<any> {
    return this.http
      .post<any>(`${this.apiUrl}/confirmacaoLimpezaFazenda`, email)
      .pipe(retry(this.NUMERO_TENTATIVAS_REQUEST), catchError(this.handleError));
  }

  enviaEmailErroCadastro(email: Email) {
    return this.http
      .post<any>(`${this.apiUrl}/erroCadastro`, email)
      .pipe(retry(this.NUMERO_TENTATIVAS_REQUEST), catchError(this.handleError));
  }

  handleError = (error: HttpErrorResponse) => {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
      // if (error.status === 404) {
      //     this.router.navigateByUrl('/404', { skipLocationChange: true });
      // }
      console.log(error);
    }
    // return an observable with a user-facing error message
    return throwError('Erro ao executar operação');
  }

}

